import { logClientError } from '../actions/logging';

export default function errorCatcher(cb) {
  function notify(err, store, action) {
    if (cb) {
      cb(err, store, action);
    }
  }

  return (store) => (next) => (action) => {
    /* eslint-disable consistent-return */
    if (action === null) {
      // we return null in some action creators due to conditionals
      // so we want to ignore these actions and not send them down the pipeline
      return;
    }

    if (action === undefined) {
      // This is a temporary log to make sure we're not unintentionally short-circuiting any action
      // creators. Once we're in the clear, we can migrate away from explicit-null to implicit-
      // undefined short-circuiting for action creators, as we would for any other function.
      store.dispatch(
        logClientError({
          message: 'Undefined action dispatched',
          context: { stackTrace: new Error().stack },
        }),
      );
    }

    try {
      const finalAction = next(action);
      notify(null, store, finalAction);
      return finalAction;
    } catch (err) {
      notify(err, store, action);
      return err;
    }
  };
}
